// extracted by mini-css-extract-plugin
export default {"container":"AlertRow_container__PSHGT","action":"AlertRow_action__DIo9y"};